import React from 'react';
import styled from 'styled-components';
import { Container } from '../styles/components';
import SectionNumber from './SectionNumber';

const DetailSection = styled.section`
  min-height: calc(100svh - 100px);
  padding: 100px 0;
  position: relative;
  background: ${props => props.theme.colors.charcoal};
  display: flex;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/assets/patterns/Contours - clipped (dark).svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 1;
    z-index: 1;
  }
`;

const DetailContainer = styled(Container)`
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.xl};
`;

const DetailHeading = styled.h2`
  font-family: ${props => props.theme.typography.heading.fontFamily};
  font-weight: ${props => props.theme.typography.heading.fontWeight};
  font-size: 2.5rem;
  line-height: 1.1;
  color: ${props => props.theme.colors.bone};
  margin: 0;
  text-align: center;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 2rem;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${props => props.theme.spacing.md};
`;

const DetailImage = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  object-fit: contain;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    max-width: 250px;
  }
`;

const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: ${props => props.theme.spacing.xxl};
  width: 100%;
  align-items: start;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${props => props.theme.spacing.lg};
  }
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.lg};
`;

const MediaColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.md};
`;

const ColumnLabel = styled.h3`
  font-family: ${props => props.theme.typography.body.fontFamily};
  font-weight: 600;
  font-size: ${props => props.theme.typography.sizes.h5};
  line-height: 1.3;
  color: ${props => props.theme.colors.bone};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const ColumnText = styled.div`
  line-height: 1.6;
  color: ${props => props.theme.colors.bone};
  font-weight: 400;
  font-size: ${props => props.theme.typography.sizes.body};
  font-family: ${props => props.theme.typography.body.fontFamily};

  p {
    margin: 0 0 1rem 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const Callout = styled.p`
  font-family: ${props => props.theme.typography.highlight.fontFamily};
  font-weight: ${props => props.theme.typography.highlight.fontWeight};
  font-style: ${props => props.theme.typography.highlight.fontStyle};
  font-size: ${props => props.theme.typography.sizes.bodyLarge};
  line-height: 1.3;
  color: ${props => props.theme.colors.gold};
  margin: ${props => props.theme.spacing.md} 0 0 0;
`;

const VideoPlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  background: ${props => props.theme.colors.bone};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.charcoal};
  font-family: ${props => props.theme.typography.body.fontFamily};
`;

const MethodologyPersuasion = () => {
  return (
    <DetailSection id="methodology-persuasion">
      <DetailContainer>
        <DetailHeading>Layer 2: Persuasion</DetailHeading>

        <ImageWrapper>
          <DetailImage
            src="/assets/sauce.png"
            alt="Layer 2: Persuasion - Meat and Sauce"
          />
        </ImageWrapper>

        <ContentLayout>
          <TextColumn>
            <ContentBlock>
              <ColumnLabel>What It Is</ColumnLabel>
              <ColumnText>
                <p>The meat and sauce. This is where the flavor comes from. The substance that makes people actually want what you're serving.</p>
                <p>What claims are you making? In what order? With what evidence?</p>
              </ColumnText>
              <Callout>
                This 'narrative+' layer brings it all together
              </Callout>
            </ContentBlock>

            <ContentBlock>
              <ColumnLabel>How We Do It</ColumnLabel>
              <ColumnText>
                <p>Placeholder for description text.</p>
              </ColumnText>
            </ContentBlock>
          </TextColumn>

          <MediaColumn>
            <VideoPlaceholder>
              Video placeholder
            </VideoPlaceholder>
          </MediaColumn>
        </ContentLayout>
      </DetailContainer>
      <SectionNumber number={6} />
    </DetailSection>
  );
};

export default MethodologyPersuasion;
